import { buildAppUrl } from './app-url.util';

/**
 * Builds an absolute URL into the admin app for a given in-app route.
 *
 * Thin alias over {@link buildAppUrl} — see that function for how the per-environment base href
 * (`/admin/` in prod, subdomain root in staging) is preserved.
 */
export function buildAdminUrl(adminAppUrl: string | undefined | null, route: string): string {
	return buildAppUrl(adminAppUrl, route);
}
